import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgendaComponentV3 } from './agenda.component';
import { BodisplayModule } from '../bodisplay';
import { ZoomModule } from '../zoom';
import { PipeModule } from '../pipes';
import { AgendaQueovalServiceV3 } from './agenda.queoval.services';
import { AfficheComponentV3 } from './affiche/affiche.component';
import { AfficheMonthComponentV3 } from './affiche/month/affiche.month.component';
import { AfficheWeekComponentV3 } from './affiche/week/affiche.week.component';
import { AffichePlanningComponentV3 } from './affiche/planning/affiche.planning.component';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    BodisplayModule,
    ZoomModule,
    PipeModule,
    VirtualScrollerModule
    //////SelectModule,
  ],
  declarations: [
    AgendaComponentV3,
    AfficheComponentV3,
    AfficheMonthComponentV3,
    AfficheWeekComponentV3,
    AffichePlanningComponentV3
    //////SelectComponent
  ],
  exports: [
    AgendaComponentV3,
    AfficheComponentV3
    //////SelectComponent
  ],
  providers: [
    AgendaQueovalServiceV3
  ]
})
export class AgendaModuleV3 { }
